import { useMutation } from "@apollo/client";

import { useGame } from "../../../../../../contexts/game/GameContext";
import { GAME_VISUALS_UPDATE, SWIPER_CONFIGURATION_UPDATE } from "../../../../../../graphql/mutations/GameMutation";
import { Form } from "./Form";
import { GAME_ALL } from "../../../../../../graphql/queries/GameQueries";
import { useProject } from "../../../../../../contexts/project/ProjectContext";
import { GameVisualsUpdateInput, SwiperConfigurationUpdateInput } from "../../../../../../gql/graphql";
import { isWordleGame } from "../../../../../../graphql/helpers/isWordleGame";
import { CustomizeVisualsWordle } from "./CustomizeVisualsWordle";

export const CustomizeVisuals = () => {
  const { currentGame } = useGame();
  const { project } = useProject();
  const [updateGameVisuals] = useMutation(GAME_VISUALS_UPDATE, {
    refetchQueries: [{ query: GAME_ALL, variables: { projectId: project?.id } }],
  });

  const [updateSwiperConfiguration] = useMutation(SWIPER_CONFIGURATION_UPDATE);

  if (!currentGame) {
    return null;
  }

  const handleUpdate = (gameVisuals: GameVisualsUpdateInput) => {
    updateGameVisuals({
      variables: {
        gameVisualsId: currentGame.configuration.gameVisuals.id,
        data: gameVisuals,
      },
    });
  };

  const handleUpdateSwiperConfiguration = (swiperConfiguration: SwiperConfigurationUpdateInput) => {
    updateSwiperConfiguration({
      variables: {
        swiperConfigurationId: currentGame.configuration.id,
        data: swiperConfiguration,
      },
    });
  };

  if (isWordleGame(currentGame)) {
    return <CustomizeVisualsWordle key={currentGame.id} game={currentGame} onUpdate={handleUpdate} />;
  }

  return (
    <Form
      key={currentGame.id}
      game={currentGame}
      onUpdate={handleUpdate}
      onUpdateSwiperConfiguration={handleUpdateSwiperConfiguration}
    />
  );
};
